import { BarcodeFormat, DecodeHintType } from '@zxing/library';

/**
 * Symbologies used by vendor membership labels (DRB, EverWash) plus QR for the
 * vendors that print one. ZXing scans every enabled format on every frame, so
 * leaving the default "all formats" on spends most of the per-frame budget on
 * matrix codes we never print (Aztec, Data Matrix, PDF417, MaxiCode).
 */
export const MEMBERSHIP_BARCODE_FORMATS: BarcodeFormat[] = [
  BarcodeFormat.CODE_128,
  BarcodeFormat.CODE_39,
  BarcodeFormat.CODE_93,
  BarcodeFormat.ITF,
  BarcodeFormat.CODABAR,
  BarcodeFormat.EAN_13,
  BarcodeFormat.EAN_8,
  BarcodeFormat.UPC_A,
  BarcodeFormat.UPC_E,
  BarcodeFormat.QR_CODE,
];

/**
 * Decoder hints shared by the live camera scanner and the image-upload path so
 * both surfaces accept the same labels.
 *
 * `TRY_HARDER` makes ZXing scan additional rows and retry rotated/inverted
 * variants instead of giving up after its single fast pass. It costs CPU per
 * frame, which is why the format list above is narrowed at the same time.
 *
 * Returns a fresh Map per call: `BrowserMultiFormatReader` keeps a reference to
 * the map it is given and can mutate it via `setHints`.
 */
export function createMembershipBarcodeHints(): Map<DecodeHintType, unknown> {
  return new Map<DecodeHintType, unknown>([
    [DecodeHintType.POSSIBLE_FORMATS, MEMBERSHIP_BARCODE_FORMATS],
    [DecodeHintType.TRY_HARDER, true],
  ]);
}
